import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faQuestionCircle,
  faTicketAlt,
  faCalendarAlt,
  faSearch,
  faInbox,
  faUser,
  faCog,
  faShieldAlt,
  faLightbulb,
  faArrowRight,
  faDog,
  faFileInvoice,
  faTasks,
} from "@fortawesome/free-solid-svg-icons";
import { version } from "os";

export const NAV_ITEMS = [
  { href: "/animals", blank: false, label: "Tierverwaltung", icon: faDog },
  { href: "/treatment", blank: false, label: "Behandlungen", icon: faTasks },
  {
    href: "https://rechnungen.tiergesundheit-hembergen.de",
    blank: true,
    label: "Rechnungen",
    icon: faFileInvoice,
  },

  //{ href: "/settings", blank: false, label: "Einstellungen", icon: faCog },
];

export const SIDEBAR_ITEMS = [
  { href: "/search", label: "Suche", icon: faSearch },
  { href: "/", label: "Dashboard", icon: faInbox },
];

export const DROPDOWN_ITEMS = [
  { type: "divider" },
  {
    href: "https://www.tiergesundheit-hembergen.de",
    label: "Datenschutz",
    icon: faShieldAlt,
  },
  { type: "divider" },
  { href: "/auth/signout", label: "Ausloggen", icon: faArrowRight },
];

export const METADATA = {
  title: "Tiergesundheit Hembergen",
  description: "Die Tierarztpraxis für Hembergen und Umgebung",
  version: "1.1.5",
};
